import type { FC } from 'react';
import {
  DaysField,
  HourField,
  MinuteField,
  MonthsField,
  TimezoneField,
  WeekDaysField,
} from './cronFields';
import type { CronEveryOption } from './cronTypes';

type CronPresetFieldsProps = {
  everyValue: Exclude<CronEveryOption, 'custom'>;
  disabled?: boolean;
};

export const CronPresetFields: FC<CronPresetFieldsProps> = ({
  everyValue,
  disabled = false,
}) => {
  const isHourFrequency = everyValue === 'hour';
  const shouldShowWeekDays = everyValue === 'week';
  const shouldShowMonthDays = everyValue === 'year' || everyValue === 'month';
  const shouldShowMonths = everyValue === 'year';

  return (
    <div className='flex flex-col gap-4'>
      {shouldShowMonths ? (
        <MonthsField everyValue={everyValue} disabled={disabled} />
      ) : null}
      {shouldShowMonthDays ? (
        <DaysField everyValue={everyValue} disabled={disabled} />
      ) : null}
      {shouldShowWeekDays ? (
        <WeekDaysField everyValue={everyValue} disabled={disabled} />
      ) : null}
      <div className='flex gap-2 items-start'>
        <span className='text-sm font-medium flex-[0_0_1rem] leading-8'>
          at
        </span>
        {isHourFrequency ? (
          <MinuteField disabled={disabled} />
        ) : (
          <>
            <HourField disabled={disabled} />
            <span className='text-lg font-medium'>:</span>
            <MinuteField disabled={disabled} />
          </>
        )}
        <TimezoneField disabled={disabled} />
      </div>
    </div>
  );
};
